// * AXIOS
// export const BASE_URL = "https://accommodation-api.37nationalgamesgoa.in/api/"; // * Local BASE URL


// export const BASE_URL = "http://localhost:8080/api/";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// * Vite CONFIG
// export const SERVER_URL = "https://accommodation-api.37nationalgamesgoa.in/"; // * Local Server URL

// export const SERVER_URL = "http://localhost:8080/";
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

